import {
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CartService } from "../../services/cart.service";
import { ContactoService } from "../../services/contacto.service";
import { StoreService } from "../../services/store.service";
import { Subject } from "rxjs";
import { CartService as CartStoreService } from "../../services/cart/cart.service";
declare var $: any;
import { LANG_MODAL_ID, LangModalComponent } from "../../shared/modals/lang-modal/lang-modal.component";
import { NgxSmartModalService } from "ngx-smart-modal";

@Component({
  selector: "main-layout",
  templateUrl: "./main-layout.component.html",
  styleUrls: ["./main-layout.component.scss"],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();

  public showMenu = false;

  constructor(
    public storeService: StoreService,
    private cartService: CartService,
    private contactoService: ContactoService,
    private _translate: TranslateService,
    private _cart: CartStoreService,
    private modalService: NgxSmartModalService,
  ) {}

  ngOnInit() {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  useLanguage(language: string) {
    if (language === this._translate.currentLang) {
      return;
    } else {
      this._cart.remove();
      this.cartService.clearCart();
      setTimeout(() => {
        this.storeService.lenguajeObservable$.next(language);
        this.cartService.recalcularPrecio();
        this.contactoService.cambioIdioma$.next();
      }, 500);
    }
  }

  openLangModal() {
    this.modalService
    .create(LANG_MODAL_ID, LangModalComponent, {
      closable: true,
      customClass: "sub-modal",
    })
    .open()
    .onAnyCloseEventFinished.subscribe(() => {
      this.modalService.removeModal(LANG_MODAL_ID);
    });
  }
}
